/**
 * Settings Module Exports
 */

export * from "./faq.interface";
export * from "./privacy-policy.interface";
export * from "./terms-condition.interface";
